











































































































































import {Component, Vue, Prop} from "vue-property-decorator"
import axios, {AxiosResponse} from "axios";
import AuthApi from "@/api/AuthApi";
@Component({})
export default class ModalChangeDomains extends Vue {
  public showPopup: boolean = false
  public isLoaded: boolean = false

  @Prop() domainId: string = ''
  @Prop() domainName: string = ''
  @Prop() domainsHostingURL: string = ''
  @Prop() domainHostingLogin: string = ''
  @Prop() domainHostingPass: string = ''
  @Prop() domainsRegisterURL: string = ''
  @Prop() domainRegisterLogin: string = ''
  @Prop() domainRegisterPass: string = ''
  @Prop() domainPrice: string = ''
  @Prop() domainDate: string = ''
  @Prop() domainsHostingService: boolean = true
  @Prop() domainsRegisterService: boolean = true

  created(){
    (window as any).modalChange = this
  }

  show(){
    this.showPopup = true
    this.$forceUpdate()
  }

  hide(){
    this.showPopup = false
    this.$forceUpdate()
  }

  private async submitDomains(){
    const data = {
      id: this.domainId,
      domain: this.domainName,
      paidDate: this.domainDate,
      domainUrl: this.domainsRegisterURL,
      domainLogin: this.domainRegisterLogin,
      domainPass: this.domainRegisterPass,
      hostUrl: this.domainsHostingURL,
      hostLogin: this.domainHostingLogin,
      hostPass: this.domainHostingPass,
      price: this.domainPrice,
      serviceDomain: this.domainsRegisterService,
      serviceHost: this.domainsHostingService
    }
    if (this.domainName != ''){
      this.isLoaded = true
      // @ts-ignore
      const store: any = JSON.parse(localStorage.getItem('session'))
      if (store.token){
        await axios.put(AuthApi.API_URL + '/api/domains', data, {
          headers: {
            'authorization': 'Bearer ' + store.token
          }
        })
            .then((res) => {
              if (res.data.status == true){
                alert(res.data.message)
                this.domainName = '';
                this.domainDate = '';
                this.domainsRegisterURL = '';
                this.domainRegisterLogin = '';
                this.domainRegisterPass = '';
                this.domainsHostingURL = '';
                this.domainHostingLogin = '';
                this.domainHostingPass = '';
                this.domainPrice = '';
                this.isLoaded = false;
                (window as any).domains.getDomains();
                this.hide()
                this.$forceUpdate();
              } else {
                this.isLoaded = false;
                alert(res.data.message)
              }
            })
            .catch(e => {
              this.isLoaded = false;
              localStorage.removeItem('session')
              this.$router.push('/login')
            })
      }
    }
  }

}

